<template>
  <div class="home">
    <div class="main-content" v-if="isMaxScreen">
      <div
        class="logistics-information"
        :style="
          !status ? `background-image: url(${require('../../../assets/image/order/30.png')});` : ''
        "
      >
        <!-- 物流信息 -->
        <h5>{{ $t('component.tradeInProcess.logisticInfo') }}</h5>
        <!-- 暂无物流信息 -->
        <div class="empty" v-if="status">
          <img src="../../../assets/image/order/empty.png" alt="" class="empyt-img" />
          <span class="empty-text">{{ $t('component.tradeInProcess.available') }}</span>
          <!-- <button class="empty-btn">Download shipping label</button> -->
        </div>
        <template v-else>
          <!-- 物流step -->
          <div class="steps">
            <div class="logistics-num">
              {{ logisticsInfo?.mailNo }}
              <img
                src="../../../assets/image/order/19.png"
                alt=""
                class="copy"
                v-clipboard:copy="logisticsInfo?.mailNo"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              />
            </div>
          </div>

          <div class="steps-list">
            <div class="steps-list-box">
              <div
                class="logistics-status"
                :class="{ 'logistics-status2': item.time == '' }"
                v-for="(item, index) in logisticsList"
                :key="index"
              >
                <img
                  :src="
                    item.time
                      ? require(`../../../assets/image/order/20.png`)
                      : require(`../../../assets/image/order/21.png`)
                  "
                  alt=""
                  class="logistics-status-selected"
                />
                <div class="logistics-status-item">
                  <span class="logistics-status-item-status">{{ statusList[index] }}</span>
                  <span class="logistics-status-item-content"
                    >{{ item.time ? formatDate(item.time) : '' }} {{ item.description || '' }}</span
                  >
                </div>
              </div>
            </div>
            <!-- <img
              :src="
                require(
                  `../../../assets/image/order/${15 + Number(logisticsInfo.logisticsTracks.length)}.png`
                )
              "
              class="step-img"
            /> -->
            <img :src="currentStatusImage" class="step-img" />
      
          </div>
        </template>
        <div
          v-if="logisticsInfo && ![2, 3, 4].includes(logisticsInfo.currentStatus)"
          class="view-logistics-page-box"
        >
          <el-button class="view-logistics-page" @click="viewLogistics">{{
            $t('component.tradeInProcess.logistic')
          }}</el-button>
        </div>
      </div>
    </div>
    <div class="main-content" v-else-if="isMaxScreen === false">
      <div class="logistics-information">
        <!-- 物流信息 -->
        <h5>{{ $t('component.tradeInProcess.logisticInfo') }}</h5>
        <!-- 暂无物流信息 -->
        <div class="empty" v-if="status">
          <img src="../../../assets/image/order/empty.png" alt="" class="empyt-img" />
          <span class="empty-text">{{ $t('component.tradeInProcess.available') }}</span>
          <!-- <button class="empty-btn">Download shipping label</button> -->
        </div>
        <!-- 物流step -->
        <div class="steps" v-else>
          <div class="logistics-num">
            {{ $t('component.tradeInProcess.logisticNum') }}: {{ logisticsInfo?.mailNo }}
            <div
              v-clipboard:copy="logisticsInfo?.mailNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
              class="copy"
            >
              {{ $t('component.tradeInProcess.656g0lj3esf3') }}
            </div>
          </div>
          <!--  -->
          <van-steps
            direction="vertical"
            :active="logisticsInfo.logisticsTracks.length - 1"
            active-color="#ebedf0"
            length="3"
          >
            <van-step v-for="(item, index) in logisticsList" :key="index">
              <template #inactive-icon>
                <img
                  src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/step-inactive.png"
                  alt=""
                  class="step-icon"
                />
              </template>
              <template #active-icon>
                <img
                  src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/step-active.png"
                  alt=""
                  class="step-icon"
                />
              </template>
              <template #finish-icon>
                <img
                  src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/step-active.png"
                  alt=""
                  class="step-icon"
                />
              </template>
              <h3>{{ statusList[index] }}</h3>
              <p class="active-text">
                {{ item.time ? formatDate(item.time) : '' }} {{ item.description || '' }}
              </p>
            </van-step>
          </van-steps>
        </div>
        <div
          v-if="logisticsInfo && ![2, 3, 4].includes(logisticsInfo.currentStatus)"
          class="logistic-bottom-btn"
        >
          <van-button class="view-logistics-page" @click="viewLogistics">{{
            $t('component.tradeInProcess.logistic')
          }}</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatDate } from './../../../utils/util';
import { vm } from '@/locales';
export default {
  name: 'logistics',
  components: {},
  props: {
    logisticsInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      status: true,
      // statusList: [{
      //   value: 1,
      //   label: '未取件'
      // }, {
      //   value: 2,
      //   label: '已取件'
      // }, {
      //   value: 3,
      //   label: '在路上'
      // }, {
      //   value: 4,
      //   label: '已签收'
      // }, {
      //   value: 5,
      //   label: '已取消'
      // }, {
      //   value: 6,
      //   label: '已退货'
      // }],
      statusList: {
        0: vm.$t('component.tradeInProcess.Collected'),
        1: vm.$t('component.tradeInProcess.inTransit'),
        2: vm.$t('component.tradeInProcess.completed')
      },
      logisticsList: [
        { status: 1, description: '', time: '' },
        { status: 3, description: '', time: '' },
        { status: 4, description: '', time: '' }
      ],
      statusImages: {
        1: require('@/assets/image/order/16.png'),
        3: require('@/assets/image/order/17.png'),
        4: require('@/assets/image/order/18.png')
      }
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    }),
    currentStatusImage() {
      return this.statusImages[this.logisticsInfo.currentStatus];
    }
  },
  watch: {
    logisticsInfo(val) {
      if (val.currentStatus > 1 && val.currentStatus != 5) {
        this.status = false;
      }

      // let paddedArray = [...val.logisticsTracks].reverse(); // 复制原始数据数组
      // // 补充空对象直到数组长度达到三
      // while (paddedArray.length < 3) {
      //   paddedArray.push({ status: '' });
      // }
      // this.logisticsList = paddedArray;
      // for (let i = 0; i < 3; i++) {

      //   // 在这里执行您想要的操作，这里只是简单地在控制台打印迭代信息
      // }
      this.logisticsList.forEach(item => {
        val.logisticsTracks.forEach(ele => {
          if (item.status == ele.status) {
            item.description = ele.description;
            item.time = ele.time;
          }
        });
      });

      console.log(this.logisticsList);
    }
  },
  created() {},
  methods: {
    getStatusLabel(value) {
      for (var i = 0; i < this.statusList.length; i++) {
        if (this.statusList[i].value === value) {
          return this.statusList[i].label;
        }
      }
    },
    copySuccess() {
      this.$toast(vm.$t('component.tradeInProcess.copySuccess'));
    },
    copyError() {
      this.$toast.fail(vm.$t('component.tradeInProcess.copyfail'));
    },
    formatDate(originalTime) {
      const date = new Date(originalTime);

      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      return formattedTime;
    },
    viewLogistics() {
      var currentURL = window.location.href;
      var queryString = currentURL.split('?')[1];
      this.$router.push('/shippingLable?' + queryString);
    }
  }
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  .main-content {
    overflow: hidden;
  }

  h5 {
    color: var(---Text-1, #252629);
    font-family: 'PingFang SC';
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 32px;
    margin: 0;
    text-align: left;
  }
  .logistics-information {
    width: 686px;
    flex-shrink: 0;
    border-radius: 24px;
    background: #fff;
    margin: 0px auto 24px;
    padding-bottom: 20px;
    overflow: hidden;

    .logistic-bottom-btn {
      display: flex;
      justify-content: center;
    }

    .empty {
      text-align: center;
      .empyt-img {
        width: 370px;
        margin: 0 auto;
      }
      .empty-text {
        color: #333;
        font-family: 'PingFang SC';
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: block;
      }
      .empty-btn {
        width: 384px;
        height: 72px;
        flex-shrink: 0;
        border-radius: 8px;
        border: 2px solid #ff9602;
        margin-top: 24px;
        margin-bottom: 80px;
        color: #ff9602;
        font-size: 28px;
        background: #fff;
        overflow: hidden;
      }
    }

    .steps {
      .logistics-num {
        color: #333;
        font-family: 'PingFang SC';
        font-size: 28px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin: 0 32px;
        display: flex;
        align-items: center;
        .copy {
          // width: 76px;
          // height: 34px;
          // line-height: 26px;
          font-size: 20px;
          border-radius: 20px;
          border: 1px solid #999;
          text-align: center;
          margin-left: 10px;
          box-sizing: border-box;
          padding: 5px 12px;
        }
      }

      h3 {
        margin: 0;
        color: #333;
        font-family: 'PingFang SC';
        font-size: 28px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
      p {
        color: rgba(102, 102, 102, 0.8);
        font-family: 'PingFang SC';
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .view-logistics-page {
      border-radius: var(--borderRadius, 4px);
      border: 1px solid #ff9602;
      color: #ff9602;
      font-family: 'PingFang SC';
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin: 24px 32px 0;
      //width: 620px;
    }
  }
  // 让步骤条从尾部至头部的顺序反向显示
  /deep/ .van-steps {
    .van-steps__items {
      display: flex;
      flex-direction: column-reverse;
    }
    .van-step--vertical {
      padding: 8px 10px 10px 0;
    }
    .van-step--vertical .van-step__line {
      top: -34px;
      left: -15px;
      height: 100%;
      background: none !important;
      border-left: 1px dashed #ebedf0;
    }
    .van-step--process .van-step__line {
      top: -23px;
      left: -15px;
      height: 80%;
      background: none;
      border-left: 1px dashed #ebedf0;
    }

    .van-step--vertical::after {
      border-bottom-width: 1px !important;
      border: none;
    }
  }

  // .active-text{
  //   height: 30px;
  // }

  .step-icon {
    width: 32px;
    height: 32px;
  }
}
@media (min-width: 981px) {
  h5 {
    color: var(---Text-1, #252629);
    font-family: 'PingFang SC';
    font-size: 45px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    // padding: 32px;
    margin: 60px 0 0 0;
    text-align: center;
    margin-bottom: 20px;
  }
  .logistics-information {
    width: 1280px;
    flex-shrink: 0;
    border-radius: 24px;
    background: #fff;
    margin: 0 auto;
    padding-bottom: 20px;
 
    background-size: cover;

    .empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 100px;
      margin-bottom: 50px;
      .empyt-img {
        width: 370px;
        margin: 0 auto;
      }
      .empty-text {
        color: #333;
        font-family: 'PingFang SC';
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: block;
        text-align: center;
      }
      .empty-btn {
        width: 384px;
        height: 72px;
        flex-shrink: 0;
        border-radius: 8px;
        border: 2px solid #ff9602;
        margin-top: 24px;
        margin-bottom: 80px;
        color: #ff9602;
        font-size: 28px;
        background: #fff;
        overflow: hidden;
      }
    }

    .steps {
      .logistics-num {
        color: #666;
        font-family: 'PingFang SC';
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin: 0 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        .copy {
          display: inline-block;
          width: 34px;
          height: 34px;
          margin-left: 10px;
        }
      }

      h3 {
        margin: 0;
        color: #333;
        font-family: 'PingFang SC';
        font-size: 28px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
      p {
        color: rgba(102, 102, 102, 0.8);
        font-family: 'PingFang SC';
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .steps-list {
      width: 1280px;
      margin-top: 180px;
      margin-bottom: 240px;
      .step-img {
        width: 100%;
      }
      .steps-list-box {
        display: flex;
        margin-bottom: 90px;
        .logistics-status {
          width: 360px;
          display: flex;
          // justify-content: center;
          background-color: #ff9602;
          margin: 0 auto;
          padding: 24px 0;
          border-radius: 15px;
          color: #fff;
        }

        .logistics-status2 {
          background: #e8e8e8;
          color: rgba(153, 153, 153, 0.8);
          .logistics-status-item-status {
            color: #999;
          }
        }

        .logistics-status-selected {
          width: 25px;
          height: 25px;
          margin-left: 30px;
          margin-right: 15px;
          margin-top: 4px;
        }

        .logistics-status-item {
          display: flex;
          flex-direction: column;
          margin-right: 30px;
        }

        .logistics-status-item-status {
          color: #fff;
          font-family: 'PingFang SC';
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
        }

        .logistics-status-item-content {
          margin-top: 6px;
          color: #fff;
          font-family: 'PingFang SC';
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: 1.5;
        }
      }
    }
    .view-logistics-page-box {
      display: flex;
      justify-content: center;
      margin-bottom: 60px;
    }

    .view-logistics-page {
      //width: 270px;
      height: 70px;
      flex-shrink: 0;
      border-radius: var(--borderRadius, 4px);
      border: 1px solid #ff9602;
      margin: 0 auto;
      color: #ff9602;
      font-family: 'PingFang SC';
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    .view-logistics-page:hover {
      background: none;
    }
  }
}
</style>
